import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { StoreConnection } from "@/components/StoreConnection";
import { IntegrationGuide } from "@/components/IntegrationGuide";
import { BulkPublish } from "@/components/BulkPublish";
import { SiteConnectPrompt } from "@/components/SiteConnectPrompt";
import { ShopSyncCheck } from "@/components/ShopSyncCheck";
import { TownLinks } from "@/components/TownLinks";
import { CalcHubCard } from "@/components/CalcHubCard";
import { SubscriberInsights } from "@/components/SubscriberInsights";

export default function StorePage() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/public/products").then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e))); }, []);

  return (
    <div className="rise">
      <p className="eyebrow mb-3">theexpatstudio.com</p>
      <h1 className="font-display text-4xl sm:text-5xl text-[#3B1B48] mb-4">Store</h1>
      <p className="text-[#8C827A] mb-12 max-w-2xl">Connect your Next.js site once. Then every guide has a "Publish to theexpatstudio.com" button, and updated editions are sent to the store automatically. The files stay hosted here, and each buyer gets their own secure download links that expire.</p>
      <div className="grid grid-cols-1 lg:grid-cols-[1fr_560px] gap-12">
        <div className="space-y-10 min-w-0">
          <SiteConnectPrompt />
          <StoreConnection />
          <ShopSyncCheck />
          <CalcHubCard />
          <SubscriberInsights />
          <TownLinks />
          <BulkPublish onDone={() => api.get("/public/products").then((r) => setItems(r.data)).catch(() => {})} />
          <div>
            <h2 className="font-display text-2xl text-[#3B1B48] mb-4">Live on the store</h2>
            <div className="space-y-3" data-testid="store-feed-list">
              {items?.length === 0 && <p data-testid="store-feed-empty" className="text-[#8C827A]">Nothing published yet. Open a finished guide and click "Publish to theexpatstudio.com".</p>}
              {items?.map((p) => (
                <Link key={p.id} to={`/guides/${p.id}`} data-testid={`store-item-${p.slug}`} className="bg-[#F4EFE6] border border-[#E2D9CC] p-5 flex gap-5 hover:bg-[#EFE6F3] transition-colors">
                  <span className="font-display text-3xl text-[#C59B27] w-12">{p.issue_number}</span>
                  <div className="flex-1">
                    <p className="font-display text-lg text-[#3B1B48]">{p.title}</p>
                    <p className="eyebrow mt-2">Edition {p.edition} · PDF A${p.price_pdf_aud} · Bundle A${p.price_bundle_aud}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
        <IntegrationGuide />
      </div>
    </div>
  );
}
